// extracted by mini-css-extract-plugin
export var caretAnchor = "_v0-0";
export var dropdownContent = "_v0-1";